<template>
  <!-- Begin Page Content -->
  <div class="container-fluid">
    <!-- Page Heading -->
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
      <h1 class="h3 mb-0 text-gray-800">Images e-Visa</h1>
    </div>
    <Nav />

    <!-- Affichage d'erreur -->
    <div class="form-group">
      <div
        class="alert text-left formatted-text"
        :class="{
          'alert-danger': error,
        }"
        role="alert"
        v-show="error"
      >
        {{ this.error }}
      </div>
    </div>

    <div
      class="table-responsive"
      v-if="userPermissions.some((e) => [P_READ_DEMAND].includes(e))"
    >
      <table
        v-if="images.length != 0"
        id="tech-companies-1"
        class="table table-bordered table-striped table-hover"
      >
        <thead>
          <tr>
            <th>Titre</th>
            <th>Image</th>
            <th>Début publication</th>
            <th>Fin publication</th>
            <th>Etat</th>
            <!-- <th>Auteur</th> -->
            <th>Ajouté le</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <ImageItem
            v-for="image in images"
            :image="image"
            :key="image.id"
          />
        </tbody>
      </table>
      <div v-else>
        <p style="text-align: center">
          <br />
          Aucunes données
        </p>
      </div>
    </div>
  </div>
  <!-- /.container-fluid -->
</template>

<script>
import { mapGetters } from "vuex";

import Nav from "./Nav";
import ImageItem from "./ImageItem";
import { FETCH_IMAGES } from "../../store/actions.type";
import { SET_LOADING } from "@/store/mutations.type";

import { P_READ_DEMAND} from "@/helpers/permissions";

export default {
  name: "ImageList",
  components: {
    Nav,
    ImageItem,
  },
  data() {
    return {
      error: "",
      P_READ_DEMAND,
    };
  },
  async mounted() {
    await this.getImages();
  },
  computed: {
    ...mapGetters(["images", "userPermissions"]),
  },
  methods: {
    getImages() {
      this.$store.commit(SET_LOADING, true);
      this.$store
        .dispatch(FETCH_IMAGES)
        .catch((error) => {
          this.error = `${error}`;
          if (error.errors) {
            this.error += ` \n ${JSON.stringify(error.errors)} `;
          }
        })
        .finally(() => {
          this.$store.commit(SET_LOADING, false);
        });
    },
  },
};
</script>

<style lang="scss">
.table-hover tbody tr:hover td {
  background-color: #d0d4e4;
}
</style>